const Marionette = require('backbone.marionette');

const ERRORS = {
  not_allowed: `User with current email is forbidden to login. Please contact support`,
  session_expired: `Current session has expired. Please log in again`,
};

module.exports = Marionette.LayoutView.extend({
  template: 'login-form-template',
  events: {
    'submit #auth-form': 'onSubmitForm',
  },

  onRender() {
    const query = window.location.search;
    const isErrorRedirect = query.includes('?error');
    if (isErrorRedirect) {
      const errorType = query.substring(query.lastIndexOf('=') + 1);
      this.$el
        .find('#message')
        .removeClass('hide')
        .text(ERRORS[errorType] || 'Internal server error. Please, try again later.');
    }
  },

  emailIsValid(email) {
    return /^[^\s@]+@classwallet\.com/.test(email);
  },

  onSubmitForm(e) {
    const email = this.$el.find('#email').val();
    if (!this.emailIsValid(email)) {
      e.preventDefault();
      this.$el
        .find('#message')
        .removeClass('hide')
        .text("Current email is not valid or doesn't correspond to Classwallet domain");
    }
  },
});
